var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{attrs:{"xl":_vm.xl,"lg":_vm.other,"md":_vm.other,"sm":_vm.other,"xs":_vm.other,"gutter":1}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }